import React from "react";
import CounterUp from "../../component/counterup/CounterUp";

const CounterUpOne = () => {
  return (
    <div className="section">
      <div className="container mt-0">
        {/* <SectionTitle
          subtitle=""
          title=""
          description=""
          textAlignment="heading-light"
          textColor=""
        /> */}
        <div className="row">
          <CounterUp colSize="col-lg-3 col-6" layoutStyle="" evenTopMargin="" />
        </div>
      </div>
    </div>
  );
};

export default CounterUpOne;
